import { Helmet } from "react-helmet-async";

const BASE_URL = "https://aihub.ai";
const DEFAULT_OG_IMAGE = "https://storage.googleapis.com/gpt-engineer-file-uploads/jMMAM1KupKMQozp3VBbKmjvww2S2/social-images/social-1774303128798-Logo_new.webp";

const organizationSchema = {
  "@context": "https://schema.org",
  "@type": "Organization",
  "name": "AI Hub",
  "url": BASE_URL,
  "logo": `${BASE_URL}/logo.png`,
  "description": "AI Hub is a London-based creative innovation studio helping architects and interior designers implement AI into their practice.",
  "email": "hello@aihub.ai",
  "sameAs": [
    "https://www.instagram.com/aihub.ai",
    "https://www.linkedin.com/company/aihub-ai"
  ],
  "contactPoint": {
    "@type": "ContactPoint",
    "email": "hello@aihub.ai",
    "contactType": "customer service"
  }
};

const localBusinessSchema = {
  "@context": "https://schema.org",
  "@type": "LocalBusiness",
  "name": "AI Hub",
  "url": BASE_URL,
  "email": "hello@aihub.ai",
  "description": "Creative innovation studio specialised in AI solutions for architecture and interior design.",
  "address": {
    "@type": "PostalAddress",
    "addressLocality": "London",
    "addressCountry": "GB"
  },
  "priceRange": "$$"
};

interface SEOHeadProps {
  title: string;
  description: string;
  canonicalPath?: string;
  ogImage?: string;
  ogType?: string;
  structuredData?: Record<string, unknown>[];
}

export const SEOHead = ({
  title,
  description,
  canonicalPath = "/",
  ogImage = DEFAULT_OG_IMAGE,
  ogType = "website",
  structuredData = [],
}: SEOHeadProps) => {
  const canonicalUrl = `${BASE_URL}${canonicalPath}`;
  const allSchemas = [organizationSchema, localBusinessSchema, ...structuredData];

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={canonicalUrl} />

      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:image" content={ogImage} />
      <meta property="og:type" content={ogType} />
      <meta property="og:site_name" content="AI Hub" />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={ogImage} />

      {allSchemas.map((schema, i) => (
        <script key={i} type="application/ld+json">
          {JSON.stringify(schema)}
        </script>
      ))}
    </Helmet>
  );
};
